import { createContext, useContext, useState, useCallback } from 'react'
import uz from './strings/uz'

const dicts = { uz }
const DEFAULT_LANG = 'uz'

const LangContext = createContext({
  lang: DEFAULT_LANG,
  setLang: () => {},
  t: (key) => key,
})

function get(obj, path) {
  return path.split('.').reduce((acc, k) => (acc == null ? acc : acc[k]), obj)
}

function interpolate(template, vars) {
  if (!vars || typeof template !== 'string') return template
  return template.replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? `{${k}}`))
}

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof localStorage === 'undefined') return DEFAULT_LANG
    const stored = localStorage.getItem('lang')
    return stored && dicts[stored] ? stored : DEFAULT_LANG
  })

  const t = useCallback(
    (key, vars) => {
      const dict = dicts[lang] || dicts[DEFAULT_LANG]
      const raw = get(dict, key)
      if (raw == null) return key
      return interpolate(raw, vars)
    },
    [lang],
  )

  const setLangPersisted = useCallback((next) => {
    if (!dicts[next]) return
    setLang(next)
    if (typeof localStorage !== 'undefined') localStorage.setItem('lang', next)
  }, [])

  return (
    <LangContext.Provider value={{ lang, setLang: setLangPersisted, t }}>
      {children}
    </LangContext.Provider>
  )
}

export function useLang() {
  return useContext(LangContext)
}

export function useT() {
  return useContext(LangContext).t
}
